import * as React from "react";
import { flash } from "../modules/flash/actions";
import { useDispatch, useSelector } from "react-redux";
import Tooltip from "./Tooltip";
import { get, post } from "../utils/fetch";
import "./UploadAttachment.scss";
import { AttachmentValidationRules, InputFile, RootState } from "../modules/types";
import { useEffect } from "react";
import { setRules } from "../modules/attachment.actions";

type Props = {
  addAttachment: (attachment: string) => void;
  setLoading?: (isLoading: boolean) => void;
};

const UploadAttachment: React.FunctionComponent<Props> = ({ addAttachment, setLoading }: Props) => {
  const dispatch = useDispatch();

  const validationRules: AttachmentValidationRules | null = useSelector(
    (state: RootState) => state.attachments.data
  );

  const getAttachmentRules = async () => {
    const url = `/api/attachments/validation_rules/`;
    const resp = await get<AttachmentValidationRules>(url);

    if (resp.data) {
      dispatch(setRules(resp.data));
    } else {
      if (setLoading) setLoading(false);
    }
  };

  useEffect(() => {
    if (!validationRules) getAttachmentRules();
  }, []);

  const uploadAttachment = async (formData: FormData) => {
    if (setLoading) setLoading(true);

    const url = `/api/attachments/`;
    const resp = await post<any>(url, formData);

    if (resp.data) {
      addAttachment(resp.data.id);
    } else {
      if (setLoading) setLoading(false);
    }
  };

  const uploadFileAction = (event: any) => {
    const uploadedFile: InputFile = event.target.files[0];
    if (!event || !validationRules || !uploadedFile) return;

    if (!validationRules.validMimeTypes.includes(uploadedFile.type)) {
      dispatch(flash(`This file type is not supported.`, "error"));
    } else if (uploadedFile.size > validationRules?.maxFileSizeBytes) {
      dispatch(flash(`This filesize is too big to upload.`, "error"));
    } else {
      const formData = new FormData();
      formData.append("file", uploadedFile);
      uploadAttachment(formData);
    }
  };

  const inputTypes = (): string => {
    const inputs = validationRules?.validMimeTypes.map(x => x).join(", ");
    const inputsPlusCamera = inputs + ";capture=camera";
    return inputsPlusCamera;
  };

  return (
    <Tooltip title={"Upload Attachment"} position={"top"}>
      <div id="upload-attachment">
        <label htmlFor={`file-input`} className="attachment">
          <span className="fa-stack fa-1x">
            <i className="fas fa-circle fa-stack-2x"></i>
            <i className="fas fa-camera fa-stack-1x fa-inverse"></i>
          </span>
        </label>
        <input
          style={{ display: "none" }}
          id="file-input"
          type="file"
          accept={inputTypes()}
          onChange={e => uploadFileAction(e)}
        />
      </div>
    </Tooltip>
  );
};

export default UploadAttachment;
